import { render, staticRenderFns } from "./HasePips.vue?vue&type=template&id=1bca529e&scoped=true&"
import script from "./HasePips.vue?vue&type=script&lang=ts&"
export * from "./HasePips.vue?vue&type=script&lang=ts&"
import style0 from "./HasePips.vue?vue&type=style&index=0&id=1bca529e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bca529e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VIcon})
